/* INCOMPLETE Component?? */
import { Component, ViewChild, Input, ElementRef } from '@angular/core';
//import { MatPaginator } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
//import { DataSource } from '@angular/cdk/collections';
import { EquipmentActionsService } from './equipment-actions.service';
import { EqActionsVwMdl } from '../../../entities/actions/model';
import { CurrentSelection} from '../../../entities/global/model';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'equipment-actions',
    templateUrl: './equipment-actions.component.html',
    styleUrls: ['./equipment-actions.style.css'],
})
export class EquipmentActionsComponent {
    @Input() UserSelection : CurrentSelection;
    displayedColumns = ['TypeAsString', 'SMU/Hourmeter', 'LTD','DateAsStr', 'Cost', 'Comment'];
    actionList: EqActionsVwMdl[] = [];
    eqTableDatabase: EqTableDatabase | null;
    dataSource: EqTableDataSource | null;
    ActionsLoaded: boolean = false;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    loadSize: number = 25;
    loadingPage: number = 1;
    constructor(private _moduleService: EquipmentActionsService) {
    }
    ngOnInit() {
        this.eqTableDatabase = new EqTableDatabase(this.actionList);
        this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);
        this.retrieveNextLoad(this.loadingPage, this.loadSize);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) { return; }
                this.dataSource.filter = this.filter.nativeElement.value;
                //console.log(this.paginator);
                var ps = 5;
                if (this.paginator.pageSize > ps)
                    ps = this.paginator.pageSize;
                var k = this.paginator.length / ps;
                for (var i = 0; i < k; i++)
                    this.paginator.previousPage();
            });
    }

    retrieveNextLoad(pageNo: number, pageSize: number) {
        this._moduleService.getEquipmentActions(this.UserSelection.equipment.Id, this.loadingPage, this.loadSize).subscribe(result => {
            for (var k = 0; k < result.length; k++) {
                this.actionList.push(result[k]);
            }
            if (result.length == this.loadSize) { //means we may have next pages as well
                this.retrieveNextLoad(this.loadingPage++, this.loadSize);
                this.ActionsLoaded = false;
            } else {
                this.ActionsLoaded = true;
            }
            this.eqTableDatabase.dataChange.next(this.actionList);
        }, error => { console.log(error); });
    }

    rowClicked(row: any) {
        ////
    }
}
export class EqTableDatabase {
    dataChange: BehaviorSubject<EqActionsVwMdl[]> = new BehaviorSubject<EqActionsVwMdl[]>([]);
    get data(): EqActionsVwMdl[] { return this.dataChange.value; }
    constructor(_equipmentList: EqActionsVwMdl[]) {;
        this.dataChange.next(_equipmentList);
    }
}


export class EqTableDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
    constructor(private _exampleDatabase: EqTableDatabase, private _paginator: MatPaginator) {
        super();
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<EqActionsVwMdl[]> {
        const displayDataChanges = [
            this._exampleDatabase.dataChange,
            this._paginator.page,
            this._filterChange,
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            const data = this._exampleDatabase.data.slice().filter(
                (item: EqActionsVwMdl) => {
                    let searchStr = (item.TypeAsString).toLowerCase();
                    return searchStr.indexOf(this.filter.toLowerCase()) != -1;
                }
            );

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    disconnect() { }
}
